<template>
    <div>
        <button-secondary @click="open">
            <i class="fa fa-pencil mr-2"></i> Bearbeiten
        </button-secondary>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template slot="header">
                    Buchung bearbeiten
                </template>

                <div class="mb-4">
                    <input-text type="date" v-model="date">
                        Datum
                    </input-text>
                </div>

                <div class="mb-4 col-span-12 sm:col-span-6">
                    <input-text type="time" v-model="start" step="1800">
                        Start
                    </input-text>
                </div>

                <div class="mb-4 col-span-12 sm:col-span-6">
                    <input-text type="time" v-model="end" step="1800" :datalist="['8:30', '9:30']">
                        End
                    </input-text>
                </div>

                <div class="flex justify-end" v-show="!loading">
                    <button-primary @click="save">
                        <i class="fa fa-save mr-2"></i> Speichern
                    </button-primary>
                </div>

                <loading v-show="loading"></loading>
            </modal>
        </portal>
    </div>
</template>

<script>
import Modal from "../Modal.vue";
import ButtonSecondary from "../UI/ButtonSecondary.vue";
import InputText from "../UI/InputText.vue";
import SelectMenu from "../UI/SelectMenu.vue";
import ButtonPrimary from "../UI/ButtonPrimary.vue";
import Loading from "../UI/Loading.vue";

export default {

    name: "BookableBookingEdit",

    components: {Loading, ButtonPrimary, SelectMenu, InputText, ButtonSecondary, Modal},

    props: ['booking'],

    data: () => ({
        loading: false,
        showModal: false,
        date: null,
        start: null,
        end: null,
    }),

    computed: {
        timeValues() { // 6-22
            const length = (22 - 6) * 2 + 1;
            return Array.from({length}, (_, i) => i).map(i => {
                return (Math.floor(i / 2) + 6).toString() + ':' + (i % 2 ? '30' : '00');
            });
        },
        startValue() {
            return this.date + ' ' + this.start;
        },
        endValue() {
            return this.date + ' ' + this.end;
        },
    },

    methods: {
        open() {
            this.date = this.booking.start.substr(0, 10);
            this.start = this.booking.start.substr(11, 5);
            this.end = this.booking.end.substr(11, 5);
            this.showModal = true;
        },
        save() {
            this.loading = true;
            this.$http
                .post('/admin/bookable_bookings/' + this.booking.id, {
                    _method: 'put',
                    start: this.startValue,
                    end: this.endValue,
                    status: 'confirmed',
                })
                .then(() => {
                    this.loading = false;
                    this.showModal = false;
                    this.$root.$emit('alert', 'Eintrag gespeichert.');
                })
                .catch((error) => {
                    this.loading = false;
                    this.$root.$emit('error', error);
                });
        }
    },
}
</script>

<style scoped>

</style>
